export default "__VITE_ASSET__5KDObWdL__"